// extracted by mini-css-extract-plugin
export var acitonButtons = "_ig-0";
export var additionalIcon = "_ig-f";
export var block = "_ig-1";
export var blockContent = "_ig-7";
export var blockDescription = "_ig-8";
export var blockIcon = "_ig-9";
export var blockTitle = "_ig-6";
export var border = "_ig-a";
export var center = "_ig-l";
export var edge = "_ig-b";
export var edgeLabel = "_ig-c";
export var edgePath = "_ig-d";
export var error = "_ig-e";
export var flowchart = "_ig-g";
export var flowchartContent = "_ig-h";
export var highlighted = "_ig-3";
export var hover = "_ig-4";
export var icon = "_ig-i";
export var left = "_ig-m";
export var navButton = "_ig-j";
export var navButtons = "_ig-k";
export var right = "_ig-n";
export var selected = "_ig-2";
export var small = "_ig-5";